// Trust & Safety's ban taxonomy — the value is what UserBanEvents.category stores.
const USER_BAN_CATEGORIES = [
  { value: 'account_identity', label: 'Account & Identity' },
  { value: 'payment_payout_fraud', label: 'Payment & Payout Fraud' },
  { value: 'traffic_attribution', label: 'Traffic & Attribution' },
  { value: 'content_conduct', label: 'Content & Conduct' },
  { value: 'other', label: 'Other' }
];

const isValidUserBanCategory = category => USER_BAN_CATEGORIES.some(({ value }) => value === category);

const getUserBanCategoryLabel = category => USER_BAN_CATEGORIES.find(({ value }) => value === category)?.label || category;

module.exports = {
  USER_BAN_CATEGORIES,
  isValidUserBanCategory,
  getUserBanCategoryLabel
};
